<template>
  <div>
    <h4>Promo Code</h4>
    <small><em>*Promo codes cannot be applied retroactively</em></small>
    <hr>

    <div class="row">
      <div class="col">
        <input type="text" name="promo" class="form-control"
               placeholder="Enter a valid promo code"
               v-model="state.registrantData.promoCode">
        <button @click="checkPromo" type="button" class="btn btn-primary" style="margin-top:15px">Add Promocode</button>
      </div>
    </div>
    <br>
    <div v-if="this.state.registrantData.promoReferEmailRequired">
      <h4>Refer a Friend</h4>
      <hr>
      <div class="row">
        <div class="col">
          <input type="email" name="refer-email" class="form-control" placeholder=""
                 v-model="state.registrantData.promoReferEmail">
          <small>Enter an email address of someone who you think would be interested in NFCM, <strong>this is
            required in order for {{ state.registrantData.promoCode.toUpperCase() }} to complete
            checkout</strong></small>
        </div>
      </div>
      <br>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Promo',

  computed: {
    ...mapGetters({
      state: 'getState',
    }),

  },
  methods: {

    checkPromo: function () {
      this.$store.dispatch('lookupPromoCode', this.state.registrantData.promoCode);

      if (this.state.registrantData.promoCode.toUpperCase() === "REFER50" || this.state.registrantData.promoCode.toUpperCase() === "REFER25") {
        this.$store.commit('makePromoReferEmailRequired');
      } else {
        this.$store.commit('makePromoReferEmailNotRequired');
      }

      if (this.state.registrantData.promoCode.toUpperCase() === "COMPMD" || this.state.registrantData.promoCode.toUpperCase() === "COMPNON") {
        this.$store.commit('makeFreeRegEligibiltyRequired');
      }

    },
    fieldClassName: function (field) {

      if (!field) {
        return ''
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success'
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger'
      }
    },
    onSubmit: function () {
      console.log(this.formstate.$valid)
    }
  },
}
</script>

<style>
.required-field > label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}
</style>
